/** Eingabe im Feld „SharePoint-Website“ → volle Adresse: nur der Teil hinter `/sites/` genügt (`teams/Name` und volle Adressen gehen auch). */
export function siteFromInput(text: string, origin: string): string {
  const value = text.trim();
  if (!value) return '';
  if (/^https?:\/\//i.test(value)) {
    // Volle Adresse: Seiten- und Listenteil abschneiden, es zählt nur https://…/sites/Name (oder /teams/Name)
    try {
      const url = new URL(value);
      const part = /^\/(sites|teams)\/[^/]+/i.exec(url.pathname);
      return part ? `${url.origin}${part[0]}` : `${url.origin}${url.pathname.replace(/\/+$/, '')}`;
    } catch { return value; }
  }
  const path = value.replace(/^\/+/, '');
  return /^(sites|teams)\//i.test(path) ? `${origin}/${path}` : `${origin}/sites/${path}`;
}

/** Volle Adresse → Anzeige im Feld: ohne Mandantenteil und ohne `/sites/`. */
export function siteToInput(url: string): string {
  try {
    const path = new URL(url).pathname.replace(/^\/+|\/+$/g, '');
    return path.replace(/^sites\//i, '');
  } catch { return url; }
}
